/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ExternalLinkConfVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * ExternalLinksControllerApi - axios parameter creator
 * @export
 */
export const ExternalLinksControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllExternalLinksList: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mapio/externalLinks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalLinksControllerApi - functional programming interface
 * @export
 */
export const ExternalLinksControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalLinksControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllExternalLinksList(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExternalLinkConfVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllExternalLinksList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExternalLinksControllerApi - factory interface
 * @export
 */
export const ExternalLinksControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalLinksControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllExternalLinksList(options?: any): AxiosPromise<Array<ExternalLinkConfVO>> {
            return localVarFp.findAllExternalLinksList(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalLinksControllerApi - interface
 * @export
 * @interface ExternalLinksControllerApi
 */
export interface ExternalLinksControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalLinksControllerApiInterface
     */
    findAllExternalLinksList(options?: any): AxiosPromise<Array<ExternalLinkConfVO>>;

}

/**
 * ExternalLinksControllerApi - object-oriented interface
 * @export
 * @class ExternalLinksControllerApi
 * @extends {BaseAPI}
 */
export class ExternalLinksControllerApi extends BaseAPI implements ExternalLinksControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalLinksControllerApi
     */
    public findAllExternalLinksList(options?: any) {
        return ExternalLinksControllerApiFp(this.configuration).findAllExternalLinksList(options).then((request) => request(this.axios, this.basePath));
    }
}
